<script setup>
import dayjs from "dayjs";
import {computed} from "vue";
import {usePage} from "@inertiajs/vue3";
import {route} from "ziggy-js";

const props = defineProps({
    message: Object,
})
defineEmits(['delete'])

const page = usePage()
const isSelf = computed(() => props.message.user_id === page.props.auth.user?.id)
// An admin message never carries a real user_id to the frontend (see ChatMessage::toPublicArray()),
// so isSelf can never match it - moderators need their own broader permission to delete one,
// mirroring what ChatMessageController::destroy() already allows server-side.
const canDelete = computed(() => isSelf.value || (props.message.is_admin_message && page.props.is_chat_moderator))
</script>

<template>
    <div :class="message.is_admin_message
             ? 'bg-amber-50 dark:bg-amber-900/30 border-2 border-amber-400 dark:border-amber-500'
             : [{'bg-slate-100 dark:bg-transparent': isSelf}, {'dark:bg-gray-700': !isSelf}]"
         class="px-2 py-1 rounded-lg group">
        <div class="flex justify-between leading-120 gap-2">
            <span v-if="message.is_admin_message"
                  class="tracking-wider text-sm font-medium truncate text-amber-700 dark:text-amber-300">
                {{ $t('Administration') }}
            </span>
            <a v-else-if="message.user"
               :href="route('users.show.offers', {user: message.user_id})"
               target="_blank"
               class="tracking-wider text-sm font-medium truncate hover:underline text-blue-600 dark:text-cyan-300">
                {{ message.user.name }}
            </a>
            <span class="text-xs text-slate-500 font-normal dark:text-slate-400 shrink-0">
                {{ dayjs(message.created_at).format('HH:mm') }}
            </span>
        </div>
        <div class="font-normal text-sm break-words dark:text-slate-200 whitespace-pre-wrap flex justify-between items-end gap-2">
            <img v-if="message.type === 'gif'" :src="message.attachment_url" alt="" loading="lazy"
                 class="max-w-[200px] max-h-[200px] rounded-md"/>
            <span v-else>{{ message.body }}</span>
            <button v-if="canDelete"
                    class="opacity-0 group-hover:opacity-100 transition-opacity text-xs text-slate-400 hover:text-red-500 shrink-0"
                    @click="$emit('delete', message)">
                {{ $t('Delete') }}
            </button>
        </div>
    </div>
</template>
